import { datadogRum, RumEvent } from '@datadog/browser-rum';
import { Person } from './domain';

const applicationId = import.meta.env.VITE_DATADOG_ID;
const clientToken = import.meta.env.VITE_DATADOG_CLIENT;
const service: string = import.meta.env.VITE_DATADOG_SERVICE;

const config = import.meta.env.VITE_CONFIG || 'dev';
const env =
  config.indexOf('prod') > -1
    ? 'perform-prod'
    : config.indexOf('sta') > -1
    ? 'perform-stg'
    : config.indexOf('qa') > -1
    ? 'perform-qa'
    : 'perform-dev';

const missingDataDog = !applicationId || !clientToken || !service || config.indexOf('dev') > -1;

if (missingDataDog) {
  console.log(`Missing Datadog Configuration`);
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.debug = () => {};
} else {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.debug = () => {};

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env,
    site: 'datadoghq.com',
    beforeSend: (e: RumEvent) => {
      // @ts-ignore
      let src: string = e.resource?.url;
      if (src && src.indexOf('node_modules') > -1) {
        return false;
      }
      // @ts-ignore
      src = e.error?.message;
      if (src && src.indexOf('node_modules') > -1) {
        return false;
      }
      return true;
    },
    // sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
  //  trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
  });

  datadogRum.startSessionReplayRecording();
}

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

type Logger = {
  log(...msg: any[]): void;
  debug(...msg: any[]): void;
  info(...msg: any[]): void;
  warn(...msg: any[]): void;
  error(...msg: any[]): void;
  setLevel(level: LogLevel): void;
  action(action: string, msg: object): void;
  setUser(a: Person): void;
};

let level: LogLevel = 'info';

function logMsg(action: LogLevel | string, ...msg: any[]) {
  if (missingDataDog) {
    console.log(action, msg);
  } else {
    if (action === 'error') {
      datadogRum.addError(msg);
    } else {
      datadogRum.addAction(action, msg);
    }
  }
}

export const log: Logger = {
  action(action, msg) {
    logMsg(action, msg);
  },
  setLevel(a) {
    level = a || 'info';
  },
  setUser(a) {
    datadogRum.setUser(a);
  },
  debug(...msg) {
    logMsg('debug', msg);
  },
  info(...msg) {
    logMsg('info', msg);
  },
  warn(...msg) {
    logMsg('warn', msg);
  },
  error(...msg) {
    logMsg('error', msg);
  },
  log(...msg) {
    logMsg(level, msg);
  },
};
